<template>
  <mock-up-main>
    <div class="eitaa-device-container">
      <!-- ۱. کامپوننت مودال اختصاصی QR (داخلی) -->
      <channel-qr-modal
        v-model="showQrDialog"
        :title="value.organizationName || value.visitName || 'کانال رسمی ایتا'"
        :channel-id="cleaneitaaId || 'eitaa_id'"
        :profile-avatar="profileAvatar"
        primary-color="#e65100"
        :svg-data="qrSvgDataUrl"

      />

      <v-card
        light
        flat
        class="overflow-y-auto eitaa-preview-wrapper"
        max-height="660"
        :style="containerStyle"
      >
        <!-- ۲. بخش هدر کارت -->
        <div class="eitaa-header-section" :style="headerStyle">
          <!-- دکمه شناور نمایش QR Code -->
          <v-btn
            fab
            x-small
            elevation="4"
            class="qr-floating-btn"
            title="مشاهده و اسکن QR کد"
            @click="showQrDialog = true"
          >
            <v-icon size="18">mdi-qrcode-scan</v-icon>
          </v-btn>

          <!-- بافت پس‌زمینه هدر -->
          <div
            v-if="bgImageUrl"
            class="header-bg-texture"
            :style="{ backgroundImage: `url(${bgImageUrl})` }"
          ></div>
          <div class="header-gradient-layer"></div>
        </div>

        <div class="content-container px-4 pb-4 d-flex flex-column align-center text-center">
          <div class="avatar-wrapper mb-3">
            <v-avatar size="92" class="eitaa-avatar elevation-6">
              <img
                :src="profileAvatar"
                alt="eitaa Channel"
                style="object-fit: cover;"
                @error="$event.target.src = defaulteitaaLogo"
              />
            </v-avatar>
            <div class="eitaa-badge elevation-2" title="پیام‌رسان ایتا">
              <img
                :src="defaulteitaaLogo"
                alt="eitaa Icon"
                class="badge-icon-img"
              />
            </div>
          </div>

          <!-- عنوان کانال یا نام سازمان -->
          <h2
            class="font-weight-black text-h6 mb-1 text-truncate-2 title-glow"
            :style="{ color: textColor }"
          >
            {{ value.organizationName || value.visitName || 'کانال رسمی ایتا' }}
          </h2>

          <!-- زیرعنوان -->
          <p
            v-if="value.subtitle"
            class="eitaa-subtitle text-caption font-weight-medium mb-2"
            :style="{ color: textColor, opacity: 0.85 }"
          >
            {{ value.subtitle }}
          </p>

          <!-- شناسه ایتا (@username) -->
          <div class="eitaa-id-pill px-3 py-1 mb-3">
            <span class="id-text">@{{ cleaneitaaId || 'eitaa_id' }}</span>
            <v-icon x-small color="#ff9800" class="mr-1">mdi-link-variant</v-icon>
          </div>

          <!-- بیوگرافی -->
        <div class="bio-glass-card pa-3 mb-5 w-100">
          <p
            class="eitaa-bio text-body-2 mb-0"
            :style="{ color: textColor, opacity: 0.92 }"
          >
            {{ value.aboutUs || 'جهت دسترسی سریع و استفاده از خدمات یا عضویت در کانال، یکی از گزینه‌های زیر را لمس کنید.' }}
          </p>
          </div>
          <!-- ۳. دکمه‌های اقدام -->
          <div class="action-buttons-box w-100 px-2">
            <!-- ورود به اپلیکیشن -->
            <v-btn
              block
              x-large
              rounded
              class="mb-3 eitaa-app-btn elevation-4"
              :style="appButtonStyle"
              :href="eitaaTargetUrl"
              target="_blank"
            >
              <v-icon left size="22" class="ml-2">mdi-cellphone-message</v-icon>
              <span>{{ value.appButtonText || 'ورود به کانال ایتا' }}</span>
              <v-icon right size="18" class="arrow-icon mr-1">mdi-chevron-left</v-icon>
            </v-btn>

            <!-- نسخه وب -->
            <v-btn
              block
              x-large
              rounded
              class="mb-3 eitaa-web-btn"
              :href="eitaaWebTargetUrl"
              target="_blank"
            >
              <v-icon left size="20" class="ml-2">mdi-open-in-new</v-icon>
              <span>{{ value.webButtonText || 'مشاهده در نسخه وب ایتا' }}</span>
            </v-btn>

            <!-- کپی آدرس -->
            <v-btn
              text
              rounded
              class="copy-btn py-1"
              :class="{ 'copied-active': isCopied }"
              @click="copyeitaaLink"
            >
              <v-icon x-small class="ml-1">
                {{ isCopied ? 'mdi-check-circle' : 'mdi-content-copy' }}
              </v-icon>
              <span>{{ isCopied ? 'لینک ایتا کپی شد!' : 'کپی کردن آدرس کانال' }}</span>
            </v-btn>
          </div>

          <div style="height: 75px; width: 100%;"></div>
        </div>
      </v-card>

      <!-- فوتر شیشه‌ای -->
      <div class="modern-footer-wrapper">
        <div class="footer-gradient-fade"></div>
        <div class="footer-content px-4 pb-2">
          <div class="d-flex justify-center align-center footer-brand" @click="openLink">
            <img
              src="media/cr_logo.webp"
              alt="Terminal Ads"
              class="footer-logo ml-2"
              @error="$event.target.style.display='none'"
            />
            <span>قدرت گرفته از کیوآر لند</span>
          </div>
        </div>
      </div>
    </div>
   <transition name="fade">
      <div v-if="showPromo" class="preview-internal-overlay">      
      <PromoSheet 
        qrType="کیوآر ایتا"
        @close="showPromo = false"
        @action="handleButtonAction"
        primary-color="#E5832D"

      />
      </div>
      </transition>
  </mock-up-main>
</template>

<script>
import MockUpMain from "../../../businessPage/components/mockUp";
import ChannelQrModal from "./ChannelQrModal.vue";
import PromoSheet from "./PromoSheet.vue";

export default {
  name: "eitaaMobilePreview",
  components: {
    MockUpMain,
    ChannelQrModal,
    PromoSheet
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    qrSvgDataUrl:{type:String,default:''}
  },
  data() {
    return {
      showPromo: false,
      defaulteitaaLogo: "/media/socialnetwork/icon/eitaa.webp",
      isCopied: false,
      copyTimeout: null,
      showQrDialog: false,
    };
  },
  computed: {
    cleaneitaaId() {
      if (!this.value?.eitaaId) return "";
      return this.value.eitaaId
        .trim()
        .replace(/^https?:\/\/(www\.)?web\.eitaa\.com\/(#\/)?/i, "")
        .replace(/^https?:\/\/(www\.)?eitaa\.com\/(joinchat\/)?/i, "")
        .replace(/^@/, "")
        .replace(/\/+$/, "")
        .trim();
    },

    eitaaTargetUrl() {
      return this.cleaneitaaId
        ? `https://eitaa.com/${this.cleaneitaaId}`
        : "https://eitaa.com";
    },

    eitaaWebTargetUrl() {
      return this.cleaneitaaId
        ? `https://web.eitaa.com/#@${this.cleaneitaaId}`
        : "https://web.eitaa.com";
    },

    

    bgImageUrl() {
      const photoObj = this.value?.photo;
      const rawImg =
        photoObj?.headBackground ||
        photoObj?.bgImage ||
        photoObj?.cover ||
        photoObj?.background ||
        this.value?.headBackground ||
        this.value?.bannerImage ||
        null;

      return this.resolveFullImageUrl(rawImg);
    },

    profileAvatar() {
      const photoObj = this.value?.photo;
      const rawAvatar =
        photoObj?.profile ||
        photoObj?.logo ||
        photoObj?.avatar ||
        this.value?.avatar ||
        null;

      return this.resolveFullImageUrl(rawAvatar) || this.defaulteitaaLogo;
    },

    textColor() {
      return this.value?.pallete?.textColor || "#ffffff";
    },

    headerStyle() {
      const headBg =
        this.value?.pallete?.headColor ||
        "linear-gradient(135deg, #e65100 0%, #ff9800 100%)";

      return {
        background: headBg,
      };
    },

    appButtonStyle() {
      if (this.value?.pallete?.headColor) {
        return {
          background: `${this.value.pallete.headColor} !important`,
        };
      }
      return {};
    },

    containerStyle() {
      const bodyColor =
        this.value?.pallete?.bodyColor ||
        "linear-gradient(180deg, #2a1405 0%, #140a02 100%)";

      return {
        background: bodyColor,
        color: this.textColor,
      };
    },
  },
  beforeDestroy() {
    if (this.copyTimeout) clearTimeout(this.copyTimeout);
  },
  methods: {
    openLink(){
      window.open('https://qrland.ir', '_blank');
     },
    handleButtonAction(actionType) {
      window.open('https://core.terminalads.com/#/login', '_blank');
    },
    resolveFullImageUrl(img) {
      if (!img) return null;

      if (Array.isArray(img)) {
        img = img[0];
        if (!img) return null;
      }

      if (typeof img === "object") {
        if (img.url && typeof img.url === "string") {
          img = img.url;
        } else if (img[""] && typeof img[""] === "string") {
          img = img[""];
        } else {
          const values = Object.values(img).filter(
            (v) => typeof v === "string" && v.trim().length > 0
          );
          if (values.length > 0) {
            img = values[0];
          } else {
            return null;
          }
        }
      }

      if (typeof img === "string") {
        img = img.trim();
        if (!img) return null;

        if (
          img.startsWith("http://") ||
          img.startsWith("https://") ||
          img.startsWith("data:") ||
          img.startsWith("//") ||
          img.startsWith("blob:")
        ) {
          return img;
        }

        if (img.startsWith("upload/") || img.includes("cdn.terminalads.com")) {
          return `https://cdn.terminalads.com/${img.replace(/^\//, "")}`;
        }

        const baseUrl = this.$coreApi3 || "https://api.terminalads.com";
        const cleanPath = img.startsWith("/") ? img : `/storage/${img}`;
        return `${baseUrl.replace(/\/$/, "")}${cleanPath}`;
      }

      return null;
    },

    copyeitaaLink() {
      const link = this.eitaaTargetUrl;
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(link)
          .then(() => this.triggerCopySuccess())
          .catch(() => this.fallbackCopy(link));
      } else {
        this.fallbackCopy(link);
      }
    },

    fallbackCopy(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand("copy");
        this.triggerCopySuccess();
      } catch (err) {
        this.$toast?.error("خطا در کپی آدرس");
      }
      document.body.removeChild(textArea);
    },

    triggerCopySuccess() {
      this.isCopied = true;
      this.$toast?.success("لینک ایتا با موفقیت کپی شد.");
      if (this.copyTimeout) clearTimeout(this.copyTimeout);
      this.copyTimeout = setTimeout(() => {
        this.isCopied = false;
      }, 2500);
    },
  },
};
</script>

<style scoped>
.eitaa-device-container {
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 28px;
  overflow: hidden;
}

.eitaa-preview-wrapper {
  position: relative;
  height: 100%;
  min-height: 580px;
  z-index: 1;
  transition: all 0.35s ease;
  scrollbar-width: none;
}
.eitaa-preview-wrapper::-webkit-scrollbar {
  display: none;
}

.eitaa-header-section {
  position: relative;
  width: 100%;
  height: 125px;
  border-bottom-left-radius: 40px;
  border-bottom-right-radius: 40px;
  overflow: hidden;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.2);
  z-index: 2;
  transition: background 0.3s ease;
}

.qr-floating-btn {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 6;
  background: rgba(255, 255, 255, 0.88) !important;
  color: #e65100 !important;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  transition: transform 0.2s ease, background 0.2s ease;
}
.qr-floating-btn:hover {
  transform: scale(1.08);
  background: #ffffff !important;
}

.header-bg-texture {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  opacity: 0.45;
}

.header-gradient-layer {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.12) 0%, rgba(0, 0, 0, 0.25) 100%);
}

.content-container {
  position: relative;
  z-index: 2;
  margin-top: -46px;
}

.avatar-wrapper {
  position: relative;
  display: inline-block;
}
.eitaa-avatar {
  border: 4px solid rgba(255, 255, 255, 0.9);
  background: #ffffff;
}
.eitaa-badge {
  position: absolute;
  bottom: 4px;
  right: 4px;
  background: #ffffff;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}
.badge-icon-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 50%;
}

.title-glow {
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
}
.eitaa-subtitle {
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}
.eitaa-id-pill {
  background: rgba(255, 255, 255, 0.18);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.28);
  color: #ffffff;
  border-radius: 30px;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  direction: ltr;
}
.id-text {
  letter-spacing: 0.5px;
}
.eitaa-bio {
  line-height: 1.8;
  font-weight: 400;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  opacity: 0.95;

}
.bio-glass-card {
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 18px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.eitaa-app-btn {
  background: linear-gradient(135deg, #e65100 0%, #f57c00 100%) !important;
  color: #ffffff !important;
  font-weight: bold;
  font-size: 14.5px !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.25s ease;
}
.eitaa-app-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(230, 81, 0, 0.45) !important;
}
.arrow-icon {
  opacity: 0.75;
}

.eitaa-web-btn {
  background: rgba(255, 255, 255, 0.15) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.28) !important;
  color: #ffffff !important;
  font-weight: 500;
  font-size: 14px !important;
  transition: all 0.25s ease;
}
.eitaa-web-btn:hover {
  background: rgba(255, 255, 255, 0.25) !important;
}

.copy-btn {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 12px;
}
.copy-btn.copied-active {
  color: #4ade80 !important;
  font-weight: bold;
}

.modern-footer-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  pointer-events: none;
}
.footer-gradient-fade {
  height: 35px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.35), transparent);
}
.footer-content {
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(8px);
  pointer-events: auto;
}
.footer-brand {
  font-size: 11px;
  opacity: 0.85;
  color: #ffffff;
}
.footer-logo {
  height: 18px;
  object-fit: contain;
}
.relative-position {
  position: relative;
  overflow: hidden;
}

.preview-internal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6); 
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; 
  padding: 16px; 
}

.promo-inside-preview {
  width: 100% !important;
  max-width: 400px;
  max-height: 90%; 
  overflow-y: auto; 
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>
